import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MailIcon from '@mui/icons-material/Mail';
import {
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';

import InitialsAvatar from 'FRONTEND/components/InitialsAvatar';
import i18n from 'FRONTEND/utils/i18n';

export const ExpertSuggestion = ({
  id,
  picture,
  email,
  specialty,
  initials,
  displayName,
  duration,
  onClick = () => {},
  component,
  ...otherProps
}) => {
  const Component = component || ListItem;

  return (
    <Component
      button
      onClick={onClick}
      {...otherProps}
      component='div'
    >
      <ListItemAvatar>
        <InitialsAvatar
          edge='start'
          picture={picture}
          initials={initials}
          sideSize={40}
        />
      </ListItemAvatar>
      <ListItemText
        primary={
          <div className='appointmentForm-expertPrimary'>
            <Typography>{displayName}</Typography>
            {specialty ? (
              <Chip
                className='appointmentForm-expertSuggestionChip'
                variant='outlined'
                size='small'
                label={specialty}
              />
            ) : null}
            {duration && (
              <Tooltip title={i18n._('Appointment duration as set by the practitioner')}>
                <Chip
                  className='appointmentForm-expertSuggestionChip'
                  variant='outlined'
                  icon={<AccessTimeIcon />}
                  size='small'
                  label={`${duration}${i18n._('min')}`}
                />
              </Tooltip>
            )}
          </div>
        }
        disableTypography
        secondary={
          <Typography variant='caption' className='appointmentForm-email' component='div'>
            <span className='appointmentForm-mailIcon'><MailIcon fontSize='small' edge='start' /></span>{email}
          </Typography>
        }
      />
    </Component>
  );
};
